import { Tooltip } from '@mui/material'

export default Tooltip
